import { Activityeditor } from '@linktivity/gds-neo';
import config from '../config';

const activityApi = new Activityeditor.ActivityApi(config);

export default activityApi;
